const USERS_BASE_URL = '/users';

export const routeCreator = {
  list: () => USERS_BASE_URL,
  update: (userUuid: string) => `${USERS_BASE_URL}/${userUuid}/update`,
  create: () => `${USERS_BASE_URL}/create`,
};
